export default __webpack_public_path__ + "img/nukLogo.0d97f8a76c281273997df2da4cf16b71.png";